const FeatureTile = ({ title, desc, Icon }) => {
  return (
    <div
      className={[
        "group",
        "bg-[#F7F5F2] hover:bg-black",
        "rounded-[6px]",
        "border border-[#EFE7E1] hover:border-black",
        "px-2 md:px-6",
        "flex flex-col items-center text-center",
        "min-h-[80px] md:min-h-[120px]",
        "py-[20px] md:py-[40px]",
        "gap-[12px] md:gap-[16px]",
        "transition-all duration-300 ease-in-out",
      ].join(" ")}
    >
      {/* Icon */}
      <span className="text-[#1A1A1A] group-hover:text-white transition-colors duration-300 ease-in-out">
        <Icon />
      </span>

      {/* Title */}
      <div className="text-[#1A1A1A] group-hover:text-white font-normal text-[14px] md:text-[18px] leading-[30px] tracking-[0.17px] md:whitespace-nowrap transition-colors duration-300 ease-in-out font-inter">
        {title}
      </div>

      {/* Desc */}
      <div className="mt-2 text-[#6A7282] group-hover:text-white font-normal text-[10px] md:text-[12px] leading-[18px] tracking-[0.17px] text-center align-middle transition-colors duration-300 ease-in-out">
        {desc}
      </div>
    </div>
  );
};

export default FeatureTile;